
import React, {ButtonHTMLAttributes, FC, ReactNode} from 'react';
import classNames from 'classnames';

import {hClass, Height, Variant, vClass} from './variants';

import * as styles from './styles.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<object> {
	children?: ReactNode;
	className?: string;
	variant: Variant;
	height?: Height;
}

export const Button: FC<ButtonProps> = (props) => {
	const {children, className: cn, variant, height, ...rest} = props;
	const className = classNames(
		styles.button, cn,
		vClass(variant),
		hClass(height),
	);

	return (
		<button className={className} {...rest}>
			{children}
		</button>
	);
};
